import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Input,
  makeStyles,
  Spinner
} from "@fluentui/react-components";
import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { DeveloperPortalRootContext, useCommand, useSelector } from "@tdp/core";

const useStyles = makeStyles({
  container: {
    margin: "12px 0px 24px 0px",
    display: "grid",
    gap: "18px",
  },
  field: {
    display: "grid",
    justifyItems: "start",
  },
  input: {
    width: "85%",
  }
});

export const AdaptiveCardDialogNew: React.FC<
  {
    open: boolean,
    setOpen: (value: boolean) => void,
  }
> = ({ open, setOpen }) => {
  const classes = useStyles();
  const intl = useIntl();

  // Commands and LROs
  const create = useCommand((commands) => commands.adaptiveCardCommands.createCard);
  const resetNewCard = useCommand((commands) => commands.adaptiveCardCommands.resetNewCard);
  const isNewCardCreated = useSelector((state) => state.adaptiveCardSlice.isNewCardCreated)
  const navigate = useNavigate();
  const title = intl.formatMessage({ defaultMessage: `Design an adaptive card` });
  const [cardName, setCardName] = React.useState<string>("");
  const [isDisabled, setIsDisabled] = React.useState<boolean>(false);
  const { services: { logger } } = React.useContext(DeveloperPortalRootContext);

  const onCreateCard = () => {
    const payload = {
      cardContent: "{\"type\":\"AdaptiveCard\",\"$schema\":\"https://adaptivecards.io/schemas/adaptive-card.json\",\"version\":\"1.5\"}",
      cardType: "adaptiveCard",
      id: "",
      name: cardName
    };
    setIsDisabled(true);
    logger.logUserBi({ telemetryMarker: 'user-action-adaptive-card-create-triggered', message: `User triggered create adaptive card` });
    create(payload)
  }

  React.useEffect(() => {
    if (isNewCardCreated) {
      navigate(`/tools/cards/${isNewCardCreated}`);
      resetNewCard();
    }
  }, [isNewCardCreated])


  return (
    <Dialog open={open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent className={classes.container}>
            <div className={classes.field}>
              <Field id={"name"} label={intl.formatMessage({ defaultMessage: "Card name" })} required />
              <Input
                aria-labelledby={"name"}
                className={classes.input}
                placeholder={intl.formatMessage({ defaultMessage: "Enter the name of the card" })}
                onChange={(e) => { setCardName(e.target.value); }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={() => { setOpen(false) }}>
              {intl.formatMessage({ defaultMessage: "Cancel" })}
            </Button>
            <Button
              icon={isDisabled ? <Spinner size="tiny" /> : null}
              appearance="primary"
              disabled={!cardName || isDisabled}
              onClick={onCreateCard}>
              {intl.formatMessage({ defaultMessage: "Create" })}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );

}
